export const navMenu = [
  { title: "Home", link: "#home" },
  { title: "Tech Stack & Tools", link: "#tech" },
  { title: "Projects", link: "#projects" },
  { title: "Work Experience", link: "#workexperience" },
  { title: "Blogs", link: "#blog" },
];

export const techStack = [
  {
    title: "Languages",
    items: [
      {
        name: "JavaScript",
        badge:
          "https://img.shields.io/badge/JavaScript-323330?logo=javascript&logoColor=F7DF1E",
      },
      {
        name: "C++",
        badge:
          "https://img.shields.io/badge/C++-00599C?logo=c%2B%2B&logoColor=white",
      },
    ],
  },
  {
    title: "Frontend",
    items: [
      {
        name: "ReactJS",
        badge:
          "https://img.shields.io/badge/React-20232A?logo=react&logoColor=61DAFB",
      },
    ],
  },
  {
    title: "Backend",
    items: [
      {
        name: "Node.js",
        badge:
          "https://img.shields.io/badge/Node.js-339933?logo=node.js&logoColor=white",
      },
      {
        name: "Express.js",
        badge:
          "https://img.shields.io/badge/Express.js-000000?logo=express&logoColor=white",
      },
      {
        name: "AdonisJS",
        badge:
          "https://img.shields.io/badge/AdonisJS-5A45FF?logo=adonisjs&logoColor=white",
      },
    ],
  },
  {
    title: "Databases",
    items: [
      {
        name: "MongoDB",
        badge:
          "https://img.shields.io/badge/MongoDB-4EA94B?logo=mongodb&logoColor=white",
      },
      {
        name: "PostgreSQL",
        badge:
          "https://img.shields.io/badge/PostgreSQL-316192?logo=postgresql&logoColor=white",
      },
      {
        name: "ClickHouse",
        badge:
          "https://img.shields.io/badge/ClickHouse-FFCC01?logo=clickhouse&logoColor=black",
      },
      {
        name: "Studio 3T",
        badge:
          "https://img.shields.io/badge/Studio%203T-0078D7?logo=studio3t&logoColor=white",
      },
    ],
  },
  {
    title: "Cloud & APIs",
    items: [
      {
        name: "AWS Lambda",
        badge:
          "https://img.shields.io/badge/AWS_Lambda-FF9900?logo=awslambda&logoColor=white",
      },
      {
        name: "AWS EC2",
        badge:
          "https://img.shields.io/badge/AWS_EC2-FF9900?logo=amazonec2&logoColor=white",
      },
      {
        name: "AWS Kinesis",
        badge:
          "https://img.shields.io/badge/AWS_Kinesis-FF9900?logo=amazonaws&logoColor=white",
      },
      {
        name: "AWS EventBridge",
        badge:
          "https://img.shields.io/badge/AWS_EventBridge-FF9900?logo=amazonaws&logoColor=white",
      },
      {
        name: "AWS SQS",
        badge:
          "https://img.shields.io/badge/AWS_SQS-FF9900?logo=amazonaws&logoColor=white",
      },
      {
        name: "AWS S3",
        badge:
          "https://img.shields.io/badge/AWS_S3-FF9900?logo=amazonaws&logoColor=white",
      },
      {
        name: "Firebase",
        badge:
          "https://img.shields.io/badge/Firebase-FFCA28?logo=firebase&logoColor=black",
      },
      {
        name: "Stripe",
        badge:
          "https://img.shields.io/badge/Stripe-008CDD?logo=stripe&logoColor=white",
      },
      {
        name: "Google Maps API",
        badge:
          "https://img.shields.io/badge/Google%20Maps-4285F4?logo=googlemaps&logoColor=white",
      },
    ],
  },
  {
    title: "Tools & IDEs",
    items: [
      {
        name: "Cursor",
        badge:
          "https://img.shields.io/badge/Cursor-000000?logo=cursor&logoColor=white",
      },
      {
        name: "VSCode",
        badge:
          "https://img.shields.io/badge/VSCode-007ACC?logo=visual-studio-code&logoColor=white",
      },
      {
        name: "Postman",
        badge:
          "https://img.shields.io/badge/Postman-FF6C37?logo=postman&logoColor=white",
      },
      {
        name: "Replit",
        badge:
          "https://img.shields.io/badge/Replit-667881?logo=replit&logoColor=white",
      },
    ],
  },
];

export const workExperienceData = [
  {
    id: 1,
    company: "Petpooja",
    jobTitle: "Software Engineer",
    duration: "Apr 2025 - Present",
    location: "Ahmedabad, IN",
  },
  {
    id: 2,
    company: "Sapient Codelabs",
    jobTitle: "Software Engineer",
    duration: "Jul 2023 - Apr 2025",
    location: "Surat, IN",
  },
  {
    id: 3,
    company: "Sapient Codelabs",
    jobTitle: "Software Engineer Intern",
    duration: "Jan 2023 - Jun 2023",
    location: "Surat, IN",
  },
];

export const blogPosts = [
  {
    id: 1,
    title: "The Truth About Math.random() in JavaScript: Is It Really Random?",
    excerpt:
      "If you've ever used Math.random() in JavaScript and assumed it gives you true randomness—think again. In this post, we'll break down the fascinating world behind this innocent-looking function, answer the burning question: Is it predictable?, and show you how it all works under the hood.",
    date: "May 5, 2025",
    readTime: "2 min read",
    image:
      "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*G7SxQzIAFg6a1MiRN9UCgA.png",
    mediumLink:
      "https://medium.com/@darshant17/the-truth-about-math-random-in-javascript-is-it-really-random-c7a8835e919d",
  },
  {
    id: 2,
    title: "🚢 Why Every Developer Should Learn Docker (Even Beginners) ?",
    excerpt:
      "Whether you're a frontend wizard, backend architect, mobile app dev, or data scientist — you've probably heard whispers of Docker. Maybe you've even seen those mysterious Dockerfile and docker-compose.yml files floating around GitHub. If you've ever asked:",
    date: "May 11, 2025",
    readTime: "3 min read",
    image:
      "https://miro.medium.com/v2/resize:fit:1100/format:webp/1*Uqy4aZgzoO1xRi0cmA1lkQ.png",
    mediumLink:
      "https://medium.com/@darshant17/why-every-developer-should-learn-docker-even-beginners-38ba6bbd0250",
  },
  {
    id: 3,
    title:
      "JSON Simplified: Understand the Web's Favorite Data Format in Minutes",
    excerpt:
      "Explore what JSON is, why it's become the backbone of modern web development, and how it fits into real-world applications. Whether you're a beginner or brushing up your knowledge, this guide brings clarity to JSON with practical examples and insights.",
    date: "March 06, 2022",
    readTime: "4 min read",
    image:
      "https://miro.medium.com/v2/resize:fit:4800/format:webp/1*RxoFnurzySpYtFTzOp7YKA.png",
    mediumLink:
      "https://medium.com/@darshant17/what-is-json-why-is-json-popular-some-facts-that-you-need-to-know-about-json-30dd33e39e0a",
  },
];
